import React from 'react';

interface Props {
    head: React.ReactNode;
    body: React.ReactNode;
}

import './quiz-editor__slide.scss';

export const QuizEditorSlide = ({ head, body }: Props) => {
    return (
        <div className="quiz-editor__slide">
            {head}
            {body}
        </div>
    );
};
